import PropTypes from 'prop-types'
import CreditBoosterIcon from './credit_booster.svg'
import { StyledContainer, StyledEmptyMessageContainer, StyledEmptyIcon, StyledEmptyText } from './styled-components'
import ModuleToggle from '@/containers/SubscriptionFormPageNew/Components/shared/ModuleCollapse/ModuleToggle'
import ModuleHeading from '@/containers/SubscriptionFormPageNew/Components/shared/ModuleCollapse/ModuleHeading'
import IconCarbonRocket from '@/shared/icons/IconCarbonRocket'
import useModuleCollapse from '@/containers/SubscriptionFormPageNew/Components/shared/ModuleCollapse/useModuleCollapse'
import ModuleHeader from '@/containers/SubscriptionFormPageNew/Components/shared/ModuleCollapse/ModuleHeader'
import { ModuleContent } from '@/containers/SubscriptionFormPageNew/Components/shared/ModuleCollapse/styled-components'

const CreditBoosterEmpty = ({ t }) => {
  const { expanded, toggle } = useModuleCollapse('credit-booster')

  return (
    <StyledContainer>
      <ModuleHeader clickable onClick={toggle}>
        <ModuleHeading icon={IconCarbonRocket} moduleKey='credit-booster'>
          {t('subscriptionForm:credit_booster.title')}
        </ModuleHeading>
        <ModuleToggle expanded={expanded} onToggle={toggle} moduleKey='credit-booster' />
      </ModuleHeader>
      <ModuleContent hidden={!expanded}>
        <StyledEmptyMessageContainer>
          <StyledEmptyIcon src={CreditBoosterIcon} alt='Credit Booster Icon' />
          <StyledEmptyText>{t('subscriptionForm:credit_booster.empty_text')}</StyledEmptyText>
        </StyledEmptyMessageContainer>
      </ModuleContent>
    </StyledContainer>
  )
}

CreditBoosterEmpty.propTypes = {
  t: PropTypes.func,
}

export default CreditBoosterEmpty
